import { render, staticRenderFns } from "./AddAccountPurposesComponent.vue?vue&type=template&id=66d3dad8&"
import script from "./AddAccountPurposesComponent.vue?vue&type=script&lang=js&"
export * from "./AddAccountPurposesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports